import {ServicesDao} from '../../dao';
import {ErrorModel} from '../../models';
import {SERVICE_CODE} from './_serviceCode';

const FUNCTION_CODE = 'UPDATE_SERVICE';

export async function updateService(token: string, projectId: number | string, payload: Record<string, unknown>) {
    try {
        const result = await ServicesDao.updateService(token, projectId, payload);

        return result;
    }
    catch (error) {
        throw ErrorModel.newError({
            code: `${SERVICE_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue lors de la mise à jour du service',
            error: error
        });
    }
}
